module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-backoffice-edit-zone"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "inner-content"
  }, [(!_vm.zone.name) ? _c('LoadingSpinner') : [_c('h2', [_vm._v("Editing zone " + _vm._s(_vm.$route.params.id))]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column small-12 large-6"
  }, [_c('label', [_vm._v("Name")]), _c('TranslateField', {
    attrs: {
      "group": "entities",
      "field": _vm.zone._translatable.name,
      "label": "Name",
      "value": _vm.zone.name
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.zone.name),
      expression: "zone.name"
    }],
    staticClass: "input-group-field",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.zone.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.zone, "name", $event.target.value)
      }
    }
  })])], 1)]), _c('div', {
    staticClass: "row column"
  }, [_c('label', [_vm._v("Add from geojson"), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.zone.poly),
      expression: "zone.poly"
    }],
    attrs: {
      "rows": "10"
    },
    domProps: {
      "value": (_vm.zone.poly)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.zone, "poly", $event.target.value)
      }
    }
  })]), _c('GoogleMapContainer', [(_vm.mapCenter.lat !== 0 && _vm.mapCenter.lng !== 0) ? _c('google-map', {
    ref: "map",
    attrs: {
      "zoomControl": true,
      "mapTypeControl": true,
      "search-bar": true,
      "api-key": _vm.apiKey,
      "center": _vm.mapCenter,
      "libraries": ['places', 'visualization', 'drawing']
    }
  }, [(_vm.zone.poly) ? _c('google-map-drawing-manager', {
    attrs: {
      "initial": _vm.zone.poly
    },
    on: {
      "updated": _vm.shapeUpdated
    }
  }) : _vm._e()], 1) : _vm._e()], 1)], 1), _c('div', {
    staticClass: "row column mt-3"
  }, [_c('button', {
    staticClass: "button",
    on: {
      "click": _vm.updateZone
    }
  }, [_vm._v("Update")])])]], 2)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-fb2f3e3a!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/backoffice/EditZone.vue
// module id = 2754
// module chunks = 1